import { AppSettings } from '../app.settings';
import { OutboundScreenFiltersDataModel } from './outbound-screen-filters-data-model';

export class OutboundScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  filterData: OutboundScreenFiltersDataModel = new OutboundScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    filterData: OutboundScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.filterData = options.filterData;
    }
  }
};
